const divCardEquipment = {
  photo: 'FOTO'
};

export default divCardEquipment;
